import {classNames, React, observer, useAsync, useLocalStore, observable, action, useEffect} from '@api'
import {useCatalogItemSidebarDetailsStore, LoadingIndicator, CatalogItemSidebarDetailsStore, VipLocalStore, useVipLocalStore} from '@modules'
import {DetailsSectionConfig, DetailsViewFieldConfig, DetailsViewSectionFields, ICatalogItemChangeEventRaw, StoresInstance} from '@stores'
import {computed} from 'mobx'
import * as css from './CatalogItemChangeHistory.css'
import {CatalogItemChangeEvent} from './CatalogItemChangeEvent'

export class CatalogItemChangeHistoryStore extends VipLocalStore {
  constructor(stores: StoresInstance,public detailsStore: CatalogItemSidebarDetailsStore, public sectionFields: DetailsViewSectionFields) {
    super(stores)
    detailsStore.changeHistoryStore = this
  }

  @computed get fields() : Array<string> {
    const {sectionFields} = this

    let arr = sectionFields

    if (_.isFunction(sectionFields)) {
      arr = sectionFields(this.detailsStore.data, this.stores)
    }

    return (arr as Array<DetailsViewFieldConfig> ?? []).map(({field}) => field)
  }

  @observable.ref data: Array<ICatalogItemChangeEventRaw> = []
  @observable loading = true

  @action loadData = async () => {
    const {es, detailsStore: {id}} = this
    this.loading = true

    try {
      const {items} = es.unwrapHitsResult<ICatalogItemChangeEventRaw>(
        await es.search({
          meta: `Load change history for ${id}`,
          index: es.indexes.changeHistory,
          body: {
            //size: changeIds.length,
            query: {
              // TODO - remove once mappings are consistent everywhere
              bool: {
                minimum_should_match: 1,
                should: [
                  {match: {id}},
                  {match: {'id.keyword': id}}
                ]
              }
            },
            sort: [
              {timestamp: {order: 'desc'}}
            ]
          }
        }, {log: {query: false}}))

      this.data = items.map((item)=> {
        item.payload = _.isString(item.payload) ? JSON.parse(item.payload.toString()) : item.payload
        return item
      })
    }
    finally {
      this.loading = false
    }
    //console.log(items)
  }
}

export const CatalogItemChangeHistory = observer<React.HTMLProps<HTMLDivElement> & { section: DetailsSectionConfig }>(({className, section, ...props}) => {
  const detailsStore = useCatalogItemSidebarDetailsStore(),
    store = useVipLocalStore((ws) => new CatalogItemChangeHistoryStore(ws, detailsStore, section.fields)),
    {strings, data, loading, detailsStore: {isDirty, id}, catalog} = store

  useAsync(async () => {
    if (!isDirty || _.isEmpty(store.data)) {
      await store.loadData()
    }
  }, [catalog.es.refetchId, isDirty, id])

  return <div className={classNames(css.root, className)}>
    {loading && _.isEmpty(data)
     ? <LoadingIndicator text='Loading history...'/>
     : <div className={css.events}>
       {data.length == 0
        ? <span className={css.noResults}>{strings.noChangeHistory}</span>
        : data.map(item => <CatalogItemChangeEvent className={css.event} item={item} key={item._id}/>)}
     </div>}
  </div>
})

//CatalogItemChangeHistory['whyDidYouRender'] = true


// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/CatalogItemChangeHistory/CatalogItemChangeHistory.tsx